import { useRole } from '@/hooks/useRole'
import { Authorization, SharedProps, User } from '@/types'
import { Head, useForm, usePage } from '@inertiajs/react'
import { Button, Card, Select, Stack, TextInput, Title } from '@mantine/core'
import React from 'react'

export default function EditAuthorizationPage({ authorization }: { authorization: Authorization & { user: User } }) {
  const { current_organization } = usePage<SharedProps>().props
  const { data, setData, patch, processing, errors } = useForm({
    authorization: {
      name: authorization.user.name || '',
      role: authorization.role,
    },
  })
  const { isBoutique } = useRole()

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    patch(`/organizations/${current_organization?.slug}/authorizations/${authorization.id}`)
  }

  return (
    <>
      <Head title="Modifier l'autorisation" />

      <Stack maw={600} mx="auto" w="100%">
        <Title>Modifier l'autorisation</Title>

        <Card withBorder radius="md" p="xl" shadow="sm">
          <form onSubmit={handleSubmit}>
            <Stack gap="md">
              <TextInput label="Email (non modifiable)" value={authorization.user.email} disabled readOnly />

              <TextInput
                label="Nom"
                placeholder="Jean Dupont"
                value={data.authorization.name}
                required
                onChange={(e) => setData('authorization', { ...data.authorization, name: e.target.value })}
                error={(errors as any)['authorization.name']}
              />

              <Select
                label="Rôle"
                required
                data={[
                  { value: 'admin', label: 'Administrateur' },
                  { value: 'atelier', label: 'Atelier' },
                  { value: 'accueil', label: 'Accueil' },
                  { value: 'courier', label: 'Coursier' },
                ]}
                disabled={isBoutique}
                value={data.authorization.role}
                onChange={(value) => setData('authorization', { ...data.authorization, role: value || 'atelier' })}
                error={(errors as any)['authorization.role']}
              />

              <Button type="submit" loading={processing} mt="md" fullWidth>
                Enregistrer les modifications
              </Button>
            </Stack>
          </form>
        </Card>
      </Stack>
    </>
  )
}
